import { render, staticRenderFns } from "./ManageOrgsView.vue?vue&type=template&id=7bf46cf6&scoped=true&"
import script from "./ManageOrgsView.vue?vue&type=script&lang=ts&"
export * from "./ManageOrgsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf46cf6",
  null
  
)

export default component.exports